"use client";

import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CheckCircle2 } from "lucide-react";

gsap.registerPlugin(ScrollTrigger);

const ComparisonSection = () => {
  const containerRef = useRef(null);

  useGSAP(
    () => {
      gsap.set(".comparison-col", { autoAlpha: 0, y: 50 });
      gsap.to(".comparison-col", {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".comparison-grid",
          start: "top 65%",
          toggleActions: "play none none ",
        },
      });
    },
    { scope: containerRef },
  );

  return (
    <section
      ref={containerRef}
      className="py-32 bg-[#080808] px-4 border-y border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-clash font-bold tracking-normal text-white mb-6 leading-tight">
            Why{" "}
            <span className="bg-linear-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent">
              SmartDwara?
            </span>
          </h2>
        </div>
        <div className="comparison-grid grid md:grid-cols-3 gap-8 items-center">
          <div className="comparison-col p-8 rounded-3xl border border-white/10 bg-white/5 grayscale-0 transition-all duration-500 hover:grayscale-0">
            <h3 className="text-xl font-clash font-semibold text-gray-400 mb-6">
              Legacy Systems
            </h3>
            <ul className="space-y-4 text-sm text-gray-500 font-medium">
              <li className="flex gap-3 items-center">
                <span className="text-lg">❌</span> Slow manual entry
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-lg">❌</span> Clunky 90s Interface
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-lg">❌</span> No Mobile App
              </li>
            </ul>
          </div>
          <div className="comparison-col p-10 rounded-[32px] bg-[#111] border border-orange-500 shadow-[0_0_60px_rgba(249,115,22,0.1)] relative transform md:-translate-y-6 z-10">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#F97316] text-white text-[10px] font-bold px-4 py-2 rounded-full uppercase tracking-widest shadow-lg">
              Best Choice
            </div>
            <h3 className="text-3xl font-clash font-semibold text-white mb-8">
              Smart Dwara
            </h3>
            <ul className="space-y-5 text-gray-300 font-medium">
              <li className="flex gap-3 items-center">
                <CheckCircle2 className="w-5 h-5 text-orange-500" /> Instant QR
                Entry
              </li>
              <li className="flex gap-3 items-center">
                <CheckCircle2 className="w-5 h-5 text-orange-500" /> Zero-Ad
                Interface
              </li>
              <li className="flex gap-3 items-center">
                <CheckCircle2 className="w-5 h-5 text-orange-500" /> 99.9%
                Uptime SLA
              </li>
              <li className="flex gap-3 items-center">
                <CheckCircle2 className="w-5 h-5 text-orange-500" /> Modern
                UI/UX
              </li>
            </ul>
            <button className="w-full mt-10 py-4 bg-[#F97316] hover:bg-orange-600 hover:text-white  text-black rounded-2xl font font-clash font-semibold uppercase tracking-wide transition-all shadow-lg shadow-orange-900/20 active:scale-[0.98]">
              Start Free Trial
            </button>
          </div>
          <div className="comparison-col p-8 rounded-3xl border border-white/10 bg-white/5 grayscale-0 transition-all duration-800 hover:grayscale-0">
            <h3 className="text-xl font-clash font-bold text-gray-400 mb-6">
              ERP Giants
            </h3>
            <ul className="space-y-4 text-sm text-gray-500 font-medium">
              <li className="flex gap-3 items-center">
                <span className="text-lg">⚠️</span> Bloated Features
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-lg">⚠️</span> Invasive Ads
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-lg">⚠️</span> Complex Setup
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
